import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/home.jsx";
import About from "./pages/about.jsx";
import Login from "./pages/login.jsx";
import ChatAlfred from "./pages/chat-alfred.jsx";
import ChatAngel from "./pages/chat-angel.jsx";
import AlferdChatProvider from "./providers/alferd-chat-provider.jsx";
import AngelChatProvider from "./providers/angel-chat-provider.jsx";
import ChatAnita from "./pages/chat-anita.jsx";
import AnitaChatProvider from "./providers/anita-chat-provider.jsx";
import ChangePassword from "./pages/changePassword.jsx";
import Dashboard from "./components/dashboard.jsx";
import AddUser from "./components/addUser.jsx";
import ManageUsers from "./components/manageUsers.jsx";
import ManagePrompts from "./components/managePrompts.jsx";
import ForgotPasswordPage from "./pages/forgotPasswordPage.jsx";
import Settings from "./pages/settings.jsx";
import { initializeTheme } from "./utils/theme-utils.js";
import TestImage from "./pages/testImage.jsx";

function App() {

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/resetpassword" element={<ChangePassword />} />
      <Route path="/forgotpassword" element={<ForgotPasswordPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/feature" element={<About />} />
      <Route path="/testImage" element={<TestImage />} />

      <Route path="/dashboard" element={<Dashboard />}>
        <Route index element={<Navigate to="addUser" />} />
        <Route path="addUser" element={<AddUser />} />
        <Route path="manageUsers" element={<ManageUsers />} />
        <Route path="managePrompts" element={<ManagePrompts />} />
      </Route>

      <Route
        path="/settings"
        element={
        <Settings />
        }
      />

      <Route
        path="/chat-alferd"
        element={
          <AlferdChatProvider>
            <ChatAlfred />
          </AlferdChatProvider>
        }
      />
      <Route
        path="/chat-angel"
        element={
          <AngelChatProvider>
            <ChatAngel />
          </AngelChatProvider>
        }
      />
      <Route
        path="/chat-anita"
        element={
          <AnitaChatProvider>
            <ChatAnita />
          </AnitaChatProvider>
        }
      />
    </Routes>
  );
}

export default App;
